import { CHECK_STATUS } from '../types';
import { getAudioOutputStatus } from '@upshow/brightsign/src';

export const id = 'brightsignAudio';
export const label = 'Audio Output';

// Not `async` — this check has no real async work, and an async function with no
// `await` fails CRA's build (`require-await`). Still returns a real Promise so it
// satisfies the same contract every other check follows.
export function run (_ctx) {
  const start = Date.now();
  const status = getAudioOutputStatus();
  const durationMs = Date.now() - start;

  let result;

  if (!status.available) {
    result = {
      id,
      label,
      status: CHECK_STATUS.SKIPPED,
      detail: 'Not checked — cannot verify on this firmware',
      detailData: { notChecked: true, reason: status.reason },
      durationMs,
    };
  } else if (status.mute || status.volumeLinear === 0) {
    result = {
      id,
      label,
      status: CHECK_STATUS.FAIL,
      detail: status.mute ? 'Audio is muted' : 'Volume is at zero',
      detailData: { mute: status.mute, volumeLinear: status.volumeLinear },
      durationMs,
    };
  } else if (status.plugstate === false) {
    result = {
      id,
      label,
      status: CHECK_STATUS.AT_RISK,
      detail: 'No audio output detected',
      detailData: { plugstate: status.plugstate },
      durationMs,
    };
  } else {
    result = {
      id,
      label,
      status: CHECK_STATUS.PASS,
      detail: 'Audio output OK',
      detailData: { mute: status.mute, volumeLinear: status.volumeLinear },
      durationMs,
    };
  }

  return Promise.resolve(result);
}
